var _path, _path2, _line, _path3, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpeechBubble(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 2C13.394 2 9.26018 2 4.00028 2C2.34343 2 1 3.34315 1 5L1 17.5183C1 19.1751 2.34314 20.5183 4 20.5183L12.2979 20.5183C12.5559 20.5183 12.804 20.618 12.9902 20.7966L19.6539 27.1884C19.9717 27.4933 20.5 27.268 20.5 26.8276L20.5 20.5183L24 20.5183C25.6569 20.5183 27 19.1751 27 17.5183L27 12",
    stroke: "currentColor",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.6933 0.585787C25.9122 -0.195262 24.6459 -0.195262 23.8649 0.585787L14.2929 10.1577L14 10.4506V10.8649V13.0858C14 13.9142 14.6716 14.5858 15.5 14.5858H17.7209H18.1351L18.428 14.2929L28 4.72093C28.781 3.93988 28.781 2.67355 28 1.8925L26.6933 0.585787ZM16 12.5858V11.2791L22.6395 4.63953L23.9463 5.94625L17.3067 12.5858H16ZM25.3605 4.53204L26.5858 3.30672L25.2791 2L24.0537 3.22532L25.3605 4.53204Z",
    fill: "currentColor"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 9,
    x2: 13,
    y2: 9,
    stroke: "currentColor",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4 14H8",
    stroke: "currentColor",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 14,
    r: 1,
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeechBubble);
export default __webpack_public_path__ + "static/media/SpeechBubble.2a3cefa3.svg";
export { ForwardRef as ReactComponent };